import {
    ApplicationConfig,
    provideZoneChangeDetection,
    LOCALE_ID,
    APP_INITIALIZER,
    ErrorHandler,
    importProvidersFrom,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import localeFr from '@angular/common/locales/fr';
import { provideToastr } from 'ngx-toastr';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { headersInterceptor } from './interceptors/headers.interceptor';
import { registerLocaleData } from '@angular/common';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import * as Sentry from '@sentry/angular';
import { provideLottieOptions } from 'ngx-lottie';

// Translation imports
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { LazyTranslationLoaderService } from './services/lazy-translation-loader.service';

registerLocaleData(localeFr, 'fr');

// Lazy translation loader factory
export function createLazyTranslateLoader(http: HttpClient) {
    return new LazyTranslationLoaderService(http);
}

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
        },
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimations(),
        provideToastr(),
        provideHttpClient(
            withInterceptors([headersInterceptor, authInterceptor])
        ),
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: false || 'none',
                },
            },
        }),
        // Translation configuration with lazy loading
        provideTranslateService({
            loader: {
                provide: TranslateLoader,
                useFactory: createLazyTranslateLoader,
                deps: [HttpClient],
            },
            fallbackLang: 'fr',
        }),
        { provide: LOCALE_ID, useValue: 'fr' },
        provideLottieOptions({
            player: () => import('lottie-web'),
        }),
    ],
};
